export const facilities = {
  camera: {
    name: "最新のカメラ",
    img: require("@/assets/imgs/shindan/facilities/camera.png")
  },
  studio: {
    name: "撮影スタジオ",
    img: require("@/assets/imgs/shindan/facilities/studio.png")
  },
  arduino: {
    name: "Arduino",
    img: require("@/assets/imgs/shindan/facilities/arduino.png")
  },
  printer_3d: {
    name: "3Dプリンター",
    img: require("@/assets/imgs/shindan/facilities/printer_3d.png")
  },
  drillpress: {
    name: "ボール盤",
    img: require("@/assets/imgs/shindan/facilities/drillpress.png")
  },
  beltsander: {
    name: "ベルトサンダー",
    img: require("@/assets/imgs/shindan/facilities/beltsander.png")
  },
  lasercutter: {
    name: "レーザー加工機",
    img: require("@/assets/imgs/shindan/facilities/lasercutter.png")
  },
  epsonprinter: {
    name: "大判印刷機",
    img: require("@/assets/imgs/shindan/facilities/epsonprinter.png")
  }
};